module.exports = __webpack_public_path__ + "media/src/components/shared/general/img/logo-white-5d025e337e2624c1e76c77aefb08b5b4.png";